import React from 'react'
import {
  Box,
  Button,
  Field,
  Flex,
  Heading,
  Input,
  Message,
  Modal,
  toast,
} from '@workwhile/ui'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { addExclusionSchema, AddExclusionSchema } from '../schemas/addExclusion'
import { useAddExclusionFlowContextValue } from '../context/AddExclusionFlowProvider'
import { useRuleDetailContextValue } from '../../../context/RuleDetailProvider'
import { useRuleDetailWorkflowsContextValue } from '../../../context/RuleDetailWorkflowsProvider'

export const AddExclusionFlowMain = () => {
  const {
    state: { id: ruleId },
  } = useRuleDetailContextValue()

  const {
    addExclusionFlow: { isOpen, close },
  } = useRuleDetailWorkflowsContextValue()

  const {
    state: {
      mutationState: { isPending, errorMessage },
    },
    actions: { submit },
  } = useAddExclusionFlowContextValue()

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm<AddExclusionSchema>({
    resolver: zodResolver(addExclusionSchema),
    defaultValues: { placeGeoid: '' },
  })

  const onSubmit = handleSubmit((data) => {
    submit(
      { ruleId, placeGeoid: data.placeGeoid },
      {
        onSuccess: () => {
          toast.success('Exclusion added', { position: 'top-center' })
          reset()
          close()
        },
      }
    )
  })

  const handleClose = () => {
    reset()
    close()
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSubmit}>
            Add
          </Button>
        </Flex>
      }
    >
      <Box
        as="form"
        onSubmit={(e: React.FormEvent) => {
          e.preventDefault()
          onSubmit()
        }}
      >
        <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
          Add place exclusion
        </Heading>
        <Box mt={3}>
          <Field label="Place GEOID" error={errors.placeGeoid?.message}>
            <Input {...register('placeGeoid')} placeholder="e.g. 0667000" />
          </Field>
        </Box>
        {errorMessage ? (
          <Message variant="error" mt={3} borderRadius="small">
            {errorMessage}
          </Message>
        ) : null}
      </Box>
    </Modal>
  )
}
